import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import logEvent from 'analytics/logEvent';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store/index';
import chargePurchaseThunk from 'redux-store/thunks/purchases/chargePurchaseThunk';
import getPurchasesThunk from 'redux-store/thunks/purchases/getPurchasesThunk';

import type { PurchasesState, PurchaseType } from './types';
import type { ChargeProcessingType } from './types';

const initialState = {
  isFetched: false,
  chargeProcessing: {
    status: 'notStarted',
    details: '',
  },
  purchases: [],
} as PurchasesState;
const PurchasesSlice = createSlice({
  name: 'purchases',
  initialState,
  reducers: {
    setChargeProcessingStatus(
      state,
      action: PayloadAction<ChargeProcessingType>,
    ) {
      state.chargeProcessing.status = action.payload.status;
      state.chargeProcessing.details = action.payload.details;
    },
    chargeFinish(state, action) {
      state.chargeProcessing.status = 'fulfilled';
      state.chargeProcessing.details = 'error';

      const { success, result, params, interval, discount, price } =
        action.payload;

      if (success) {
        state.chargeProcessing.details = '';
        if (result) {
          const { amount, amount_received, receipt_email, status } = result;

          logEvent('Web_Payment_Billing_Response', {
            amount: +amount / 100,
            amount_received: +amount_received / 100,
            receipt_email,
            status,
            tariff: interval,
            plan_id: params.product_id,
            coupon: params.coupon,
            'coupon%': discount,
          });
        }

        try {
          const onboardId = window.location.search
            .slice(1)
            .split('&')
            .find(el => el.startsWith('onboardId'))
            ?.split('=')[1] as string | undefined;

          if (!onboardId) {
            return;
          }

          const beaconBody = {
            planType: interval,
            planPrice: price,
            onboardId,
          };
          const beaconHeaders = {
            type: 'application/json',
          };
          const blob = new Blob([JSON.stringify(beaconBody)], beaconHeaders);
          navigator.sendBeacon('/api/log', blob);
        } catch (e) {}

        try {
          (window as any).fbq?.('track', 'Purchase');
        } catch (e) {}
      } else {
        if (action.payload.details) {
          state.chargeProcessing.details = action.payload.details;
          logEvent('Web_Payment_Processing_Failed', {
            error: action.payload.details,
          });
        }
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(getPurchasesThunk.fulfilled, (state, action) => {
      state.isFetched = true;
      state.purchases = action.payload as PurchaseType[];
    });

    builder.addCase(chargePurchaseThunk.pending, state => {
      state.chargeProcessing.status = 'pending';
    });

    builder.addCase(chargePurchaseThunk.rejected, state => {
      state.chargeProcessing.status = 'fulfilled';
      state.chargeProcessing.details = 'some_error';
    });

    // builder.addCase(chargePurchaseThunk.fulfilled, (state, action) => {
    //   state.chargeProcessing.status = 'fulfilled';
    //   state.chargeProcessing.details = 'error';
    //
    //   const { success, result, params, interval, discount, price } =
    //     action.payload;
    //
    //   if (success) {
    //     state.chargeProcessing.details = '';
    //     if (result) {
    //       const { amount, amount_received, receipt_email, status } = result;
    //
    //       logEvent('Web_Payment_Billing_Response', {
    //         amount: +amount / 100,
    //         amount_received: +amount_received / 100,
    //         receipt_email,
    //         status,
    //         tariff: interval,
    //         plan_id: params.product_id,
    //         coupon: params.coupon,
    //         'coupon%': discount,
    //       });
    //
    //       try {
    //         const beaconBody = {
    //           planType: interval,
    //           planPrice: price,
    //         };
    //         const beaconHeaders = {
    //           type: 'application/json',
    //         };
    //         const blob = new Blob([JSON.stringify(beaconBody)], beaconHeaders);
    //         navigator.sendBeacon('/api/log', blob);
    //       } catch (e) {}
    //     }
    //
    //     try {
    //       const onboardId = window.location.search
    //         .slice(1)
    //         .split('&')
    //         .find(el => el.startsWith('onboardId'))
    //         ?.split('=')[1] as string | undefined;
    //
    //       if (!onboardId) {
    //         return;
    //       }
    //
    //       const beaconBody = {
    //         planType: interval,
    //         planPrice: price,
    //         onboardId,
    //       };
    //       const beaconHeaders = {
    //         type: 'application/json',
    //       };
    //       const blob = new Blob([JSON.stringify(beaconBody)], beaconHeaders);
    //       navigator.sendBeacon('/api/log', blob);
    //     } catch (e) {}
    //
    //     try {
    //       // @ts-ignore
    //       global.fbq?.('track', 'Purchase');
    //     } catch (e) {}
    //   } else {
    //     if (action.payload.details) {
    //       state.chargeProcessing.details = action.payload.details;
    //       logEvent('Web_Payment_Processing_Failed', {
    //         error: action.payload.details,
    //       });
    //     }
    //   }
    // });

    builder.addCase(HYDRATE, (state, action: HydrateAction<PurchasesState>) => {
      return action.payload.purchases;
    });
  },
});

export const { setChargeProcessingStatus, chargeFinish } =
  PurchasesSlice.actions;

export default PurchasesSlice.reducer;
